import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { theme } from '@xbto/design-system';
import { Button, Col, RadioBox } from '../../atoms';
import { PerformanceSettings } from './types';
export const PerformanceSettingsPrompt = ({ onSave }) => {
    /**
     * State
     */
    /**
     * Note:
     * TODO: solve modal context
     * This component is injected into Modal & somehow the outside state is lost in the modal that comes up
     * so maintaining this as an inner value
     */
    const [innerValue, setInnerValue] = useState(null);
    /**
     * Methods
     */
    const onSavePressed = useCallback(() => {
        if (!innerValue) {
            return;
        }
        onSave(innerValue);
    }, [onSave, innerValue]);
    /**
     * DOM
     */
    return (_jsxs(View, { style: $.container, children: [_jsxs(Col, { style: $.perfOptions, mb: "6", children: [_jsx(RadioBox, { title: "USD value", label: "Performance figures are shown using the USD counter-value of the assets you own (and accumulated over time) as the calculation basis.", onPress: () => setInnerValue(PerformanceSettings.USD_VALUE), active: innerValue === PerformanceSettings.USD_VALUE, value: PerformanceSettings.USD_VALUE, rounded: true, outlined: true }), _jsx(RadioBox, { title: "Asset accumulation", label: "Performance is shown by calculating the increase or decrease of the amount of the asset you now own.", onPress: () => setInnerValue(PerformanceSettings.ASSET_ACCUMULATION), active: innerValue === PerformanceSettings.ASSET_ACCUMULATION, value: PerformanceSettings.ASSET_ACCUMULATION, rounded: true, outlined: true })] }), _jsx(Button, { onPress: onSavePressed, label: "Save", disabled: innerValue === null, variant: "secondary" })] }));
};
const $ = StyleSheet.create({
    container: {
        flex: 1,
    },
    perfOptions: {
        marginBottom: theme.spacing['10'],
        rowGap: theme.spacing['2'],
    },
});
